import UltMeta, { Meta } from "./UltMeta/index";
/**
 * 展示位置
 * */
class CompanyADLocation extends UltMeta {
    ONE = new Meta(1, "广告位1");

    TWO = new Meta(2, "广告位2");

    THREE = new Meta(3, "广告位3");

    FOUR = new Meta(4, "广告位4");

    FIVE = new Meta(5, "广告位5");

    SIX = new Meta(6, "广告位6");

    SEVEN = new Meta(7, "广告位7");

    EIGHT = new Meta(8, "广告位8");
}

export const COMPANY_AD_LOCATION = new CompanyADLocation();